import React from 'react'
import styled from 'styled-components'

import { GROUP_SETTINGS_MENU_ITEMS } from 'containers/Navigation/GroupSettingsMenu/constants'

import Icon from 'components/lib/Icon'

import NavigationItem from './NavigationItem'

function GroupSettingsMenu({ className, history, setOnClickCallback, onCloseCallback }) {
  const handleLinkClick = (url) => history.push(url)
  return (
    <NavigationItem
      className={className}
      setOnClickCallback={setOnClickCallback}
      onCloseCallback={onCloseCallback}
      content={GROUP_SETTINGS_MENU_ITEMS.map((item) => (
        <div
          className="menu-item-container pc"
          onClick={() => handleLinkClick(item.url)}
          key={item.name}
        >
          <Icon className="mr vat" imageName={item.icon} width="24px" height="24px" />
          <span>{item.name}</span>
        </div>
      ))}
    />
  )
}

export default styled(GroupSettingsMenu)`
  .content {
    width: max-content;
    min-width: 196px;
    padding: 8px;
  }
  .menu-item-container {
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: 11.5px 7px;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background: var(--dropdown-hover);
    }
  }
`
